export const SET_FAQS = "SET_FAQS";
export const GET_FAQS = "GET_FAQS";
export const REFRESH_FAQS = "REFRESH_FAQS";